
/* styles */
require("!!vue-style-loader!css-loader!./../../vue-loader/lib/style-rewriter?id=data-v-7b0a85a6!sass-loader!./../../vue-loader/lib/selector?type=styles&index=0!./UiIcon.vue")

var Component = require("!./../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../vue-loader/lib/selector?type=script&index=0!./UiIcon.vue"),
  /* template */
  require("!!./../../vue-loader/lib/template-compiler?id=data-v-7b0a85a6!./../../vue-loader/lib/selector?type=template&index=0!./UiIcon.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/keen-ui/src/UiIcon.vue
// module id = 144
// module chunks = 22